import React, { useEffect } from "react";
import ClientNavbar from "../../client-navbar/components";
// import "../style/clientHeader-style.css";
import IC_logo from "../../../../assets/images/ic_logo_1.png";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout, selectClientAuth } from "../../auth-client/slice/clientAuth";
// import { incrementNotification, resetNotifications } from "../slice/chatNotificationsSlice";
// import Pusher from "pusher-js";

// const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const ClientHeader = () => {
  const dispatch = useDispatch();
      const navigate = useNavigate();
      // const unreadCount = useSelector((state) => state.chatNotifications.unreadCount);
      // const unreadCount = 1;

      // console.log("unreadCount", unreadCount);
  
      const isClientLoggedIn = useSelector(selectClientAuth);

  //     useEffect(() => {
  //   const clientToken = localStorage.getItem("client_access_token");
  //   if (!clientToken) return;

  //   const pusher = new Pusher("71055cc21a087085dc31", {
  //     cluster: "ap2",
  //     forceTLS: true,
  //     authEndpoint: `${BACKEND_URL}/pusher/auth`,
  //   });

  //   // Subscribe to a "global" channel for this client
  //   const channel = pusher.subscribe("private-chat_room");

  //   channel.bind("App\\Events\\ChatRoomCreated", (data) => {
  //     dispatch(incrementNotification());
  //   });

  //   return () => {
  //     channel.unbind_all();
  //     channel.unsubscribe();
  //     pusher.disconnect();
  //   };
  // }, [dispatch]);


  const handleClientLogout = () => {
      dispatch(logout());
      navigate("/");
    };
  return (
    <>

    <header className="header-top position-sticky top-0" style={{ zIndex: "99" }}>
         <div className="tophad bg-primary pt-2 pt-lg-3 d-none d-lg-block">
            <div className="container">
               <div className="row justify-content-end align-items-center">
                  <div className="col-auto">
                     <div className="d-flex">
                        <div className="align-items-center d-flex">
                           <div className="d-flex align-items-center">
                              {/* <div className="position-relative me-4">
                                <i className="fa fa-bell fa-lg text-white"></i>
                                
                                {unreadCount > 0 && (
                                  <span 
                                    className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                                    style={{ fontSize: "0.7rem", minWidth: "18px" }}
                                  >
                                    {unreadCount}
                                  </span>
                                )}
                              </div> */}

                              <div className="me-0 me-lg-2"><a href="#" className="text-decoration-none"><img src="/assets/images/header-gmail.svg" alt="..." className="" /></a></div>
                              <div className=""><a href="#" className="font-size-18 font-weight-semibold line-hight-3 text-white text-decoration-none">Info@justgen.org</a>
                              </div>
                           </div>
                           <div className="d-flex align-items-center ms-3 me-2  ms-md-4 me-md-3">
                              <div className="me-0 me-lg-2"><a href="#" className="text-decoration-none"><img src="/assets/images/header-call.svg" alt="..." className="" /></a></div>
                              <div className=""><a href="#" className="font-size-18 font-weight-semibold line-hight-3 text-white text-decoration-none">+757-937-1738</a>
                              </div>
                           </div>
                        </div>
                        <div className="mt-1">
                           {/* <a href="https://www.facebook.com/profile.php?id=61575600418282" target="_blank"  rel="noopener noreferrer" className="fb"></a> */}
                           <a href="https://www.facebook.com/profile.php?id=61575600418282" target="_blank" className="text-white"
  rel="noopener noreferrer"><i className="fa fa-facebook me-2"></i></a>
                           <a href="https://www.linkedin.com/company/107183458/admin/dashboard/" target="_blank" className="text-white"  rel="noopener noreferrer"><i className="fa fa-linkedin"></i></a>
                           {/* <a href="#" className="tw ms-1 ms-sm-2"></a>
                           <a href="#" className="pin ms-1 ms-sm-2"></a>
                           <a href="#" className="ista ms-1 ms-sm-2"></a> */}
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>


            <ClientNavbar />
            </header>
{/* <div className="header">
                <div className="header-left">
                    <img src={IC_logo} alt="IC Logo" className="logo-img" />
                </div>
                <div className="header-right">
        {isClientLoggedIn ? (
          <button className="header-btn" onClick={handleClientLogout}>
            Client Logout
          </button>
        ) : (
          <>
            <Link to="/signin">
              <button className="header-btn">Client Login</button>
            </Link>
            <Link to="/signup">
              <button className="header-btn">Client Register</button>
            </Link>
           
          </>
        )}
      </div>
            </div>

            <ClientNavbar /> */}
            
    </>
  );
};

export default ClientHeader ;
